<div class="bg-white flex items-center justify-between border-b border-gray-200 py-4 px-10">
  <div class="flex items-center gap-6">
    <app-logo size="sm"></app-logo>
  </div>
</div>